import React from 'react';
import Modal from '../util/Modal';

export default class WarningModal extends React.Component {
    render() {
        return (
            <Modal modalShowing={this.props.show}>
                <div className="modal-container">
                    <div className="modal warning-modal">
                        <h4 className="page-header"><i className="material-icons middle">warning</i>Warning</h4>
                        <div className="medium-text">
                            {(this.props.message && this.props.message.indexOf('\n') > 0)
                                ? <div>
                                    {this.props.message.split('\n').slice(0, 1).map((text, index) => <p key={index}>{text}</p>)}
                                    <div className="scrollable-recipients-container">{this.props.message.split('\n').slice(1).map((text, index) => <p key={index}>{text}</p>)}</div>
                                </div>
                                : <span>{this.props.message}  </span>}
                            <span className="bold-text">{this.props.confirmationMessage || "Do you still want to continue?"}</span>
                        </div>
                        <div className="warning-modal-btns text-right">
                            <button className="btn btn-accent" onClick={() => {
                                if (this.props.cancel)
                                    this.props.cancel();
                                this.props.close();
                            }}>{this.props.cancelText || "Cancel"}</button>
                            <button className="btn btn-accent2" onClick={() => {
                                this.props.continue();
                                this.props.close();
                            }}>{this.props.continueText || "Continue"}</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/WarningModal.jsx